import React, { useEffect } from 'react'
import ApiKey from './ApiKey'
import useAxios from 'hooks/useAxios'
import useUser from 'hooks/useUser'
import { Loader } from 'shared/components/Loader'
import useModal from 'hooks/useModal'

export default function ApiKeyContainer({ onModalReady }) {
  const {
    Modal: apiKeyFormModal,
    open: openApiKeyFormModal,
    close: closeApiKeyFormModal,
    isOpen: isApiKeyFormModalOpen,
  } = useModal()

  const { data: apiKeyData, loading: apiKeyDataLoading } = useAxios({
    method: 'get',
    url: 'account/api-keys/',
  })

  const { fetch: deleteApiKey, loading: deleteApiKeyLoading } = useAxios({
    method: 'delete',
    skip: true,
  })

  const user = useUser()
  const workspaceId = user?.selected_workspace?.id

  const { data: workspaceData, loading: workspaceLoading } = useAxios({
    method: 'get',
    url: `account/company/${workspaceId}/`,
    skip: !workspaceId,
  })

  useEffect(() => {
    if (onModalReady) {
      onModalReady(openApiKeyFormModal)
    }
  }, [onModalReady, openApiKeyFormModal])

  if (workspaceLoading || apiKeyDataLoading || !apiKeyData) {
    return <Loader withContainer />
  }

  return (
    <ApiKey
      apiKeyData={apiKeyData}
      legacyApiKey={workspaceData?.token || ''}
      deleteApiKey={deleteApiKey}
      deleteApiKeyLoading={deleteApiKeyLoading}
      apiKeyFormModal={apiKeyFormModal}
      openApiKeyFormModal={openApiKeyFormModal}
      closeApiKeyFormModal={closeApiKeyFormModal}
      isApiKeyFormModalOpen={isApiKeyFormModalOpen}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/ApiKey/container.js